<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <div id="myModal" class="modal">
        <span class="close">&times;</span>
        <img class="modal-content" id="img01">
        <div id="caption"></div>
    </div>
    <!-- Header Start -->
    <div class="container-fluid testimonial bg-breadcrumb py-2 wow fadeInUp" data-wow-delay="0.1s">
        <div class="container text-center py-2">
            &nbsp;
        </div>
    </div>
    <div class="container-fluid bg-breadcrumbberanda wow fadeInDown">
        <Carousel :wrap-around="true" :breakpoints="breakpoints" :autoplay="5000">
            <Slide v-for="slide in slides" :key="slide.id">
                <div class="carousel__item" style="min-height: 650px !important;"
                    :style="'background:linear-gradient(0deg, rgba(60, 60, 60, 0.5), rgba(60, 60, 60, 0.5)), url(' + slide.url + ');background-position: center;background-repeat: no-repeat;background-size: cover;background-color: rgba(223, 12, 12, 0);'">
                    <h1 class="col-sm-12 carousel__h1 animated-text"
                        style="font-style: normal;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);max-width: 65vw !important;">{{ slide.title }}</h1>
                </div>
            </Slide>
            <template #addons>
                <Navigation />
                <Pagination />
            </template>
        </Carousel>
    </div>
    <!-- Header End -->

    <div class="container-fluid py-3" v-for="(beranda, urutberanda) in databeranda" :key="urutberanda">
        <div class="container py-3">
            <div class="row g-5 align-items-center" v-if="urutberanda % 2 == 0">
                <div class="col-lg-6 wow fadeInLeft" data-wow-delay="0.4s">
                    <img :src="folder_foto + beranda.filenya_beranda"
                        class="img-fluid w-100 h-100 gambar rounded" :id="beranda.id" :alt="beranda.nama"
                        style="cursor: pointer;" v-if="beranda.tampilpublik == 1">

                    <video style="height:35vh" controls id="framevideo" v-if="beranda.tampilpublik == 2">
                        <source :src="folder_video + beranda.filenya_beranda" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                    <span v-html="beranda.filenya_beranda"  v-if="beranda.tampilpublik == 3">
                    </span>
                </div>
                <div class="col-lg-6 wow fadeInRight" data-wow-delay="0.4s">
                    <div class="section-title text-start">
                        <h4 class="sub-title pe-3 mb-0 pmistitelberita">
                            <span>{{ beranda.nama }}</span>
                        </h4>
                        <br><br>
                        <p class="mb-4">
                            <span class="text-justify" v-html="beranda.konten">
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="row g-5 align-items-center" v-else>
                <div class="col-lg-7 wow fadeInLeft" data-wow-delay="0.4s">
                    <div class="section-title text-start">
                        <h4 class="sub-title pe-3 mb-0 pmistitelberita">
                            <span>{{ beranda.nama }}</span>
                        </h4>
                        <br><br>
                        <p class="mb-4">
                            <span class="text-justify" v-html="beranda.konten">
                            </span>
                        </p>
                    </div>
                </div>
                <div class="col-lg-5 wow fadeInRight" data-wow-delay="0.4s">
                    <img :src="folder_foto + beranda.filenya_beranda"
                        class="img-fluid w-100 h-100 gambar rounded" :id="beranda.id" :alt="beranda.nama"
                        style="cursor: pointer;" v-if="beranda.tampilpublik == 1">

                    <video style="height:35vh" controls id="framevideo" v-if="beranda.tampilpublik == 2">
                        <source :src="folder_video + beranda.filenya_beranda" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                    <span v-html="beranda.filenya_beranda"  v-if="beranda.tampilpublik == 3">
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        Berita Terbaru
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        News Update
                    </h1>
                </div>
                <p class="mb-0" v-if="(bahasa === null) || (bahasa == 'ina')">
                    Berisikan berita, informasi dan kegiatan terbaru
                </p>
                <p class="mb-0" v-else>
                    Contains the latest news, information and activities
                </p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="col-md-3 col-lg-3 col-xl-3 wow fadeInUp" data-wow-delay="0.1s"
                    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;"
                    v-for="(beranda, urutberanda) in databerita" :key="urutberanda">
                    <div class="blog-item rounded">
                        <div class="blog-img gmbpmis">
                            <img v-if="(bahasa === null) || (bahasa == 'ina')" :id="beranda.id"
                                :src="folder_foto + beranda.filenya_berita" class="img-fluid w-100"
                                :alt="beranda.kontenfull" @click="ambilgambar(beranda.id)"
                                style="max-height: 200px;min-height: 200px;">
                            <img v-else :id="beranda.id" :src="folder_foto + beranda.filenya_berita"
                                class="img-fluid w-100" :alt="beranda.konten_engfull" @click="ambilgambar(beranda.id)"
                                style="max-height: 200px;min-height: 200px;">
                        </div>
                        <div class="p-4"
                            style="min-height: 370px !important;border-left: solid 1px #3a4767 !important;border-right: solid 1px #3a4767 !important;">
                            <div class="d-flex justify-content-between mb-4" style="font-size: 10px;">
                                <p class="mb-0 text-muted">
                                    <i class="fa fa-calendar-alt text-primary"></i>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        {{ G_formatDate(beranda.tanggal) }}
                                    </span>
                                    <span v-else>
                                        {{ G_formatDateEng(beranda.tanggal) }}
                                    </span>
                                </p>
                            </div>
                            <a href="javascript:void(0)" class="pmisjudulberita" @click="ambilgambar(beranda.id)">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    {{ beranda.nama }}
                                </span>
                                <span v-else>
                                    {{ beranda.nama_eng }}
                                </span>
                            </a>
                            <p style="font-size: 8px !important;">
                                <span style="font-size: 8px !important;">
                                </span>
                            </p>
                            <p v-if="(bahasa === null) || (bahasa == 'ina')">
                                <span v-html="beranda.konten"></span>
                            </p>
                            <p v-else>
                                <span v-html="beranda.konten_eng"></span>
                            </p>
                        </div>
                        <div class="text-center" style="min-height: 20px !important;background-color: #3a4767;">
                            <a href="javascript:void(0)" class="btn rounded-pill text-white py-2 px-4 mb-1"
                                @click="ambilgambar(beranda.id)" style="position: relative;bottom: -2px !important;">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Selengkapnya
                                </span>
                                <span v-else>
                                    Read more
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center wow fadeInUp" data-wow-delay="0.2s"
                    style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                    <a class="btn btn-primary rounded-pill text-white py-3 px-5" href="/DaftarBerita">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Berita Lain
                        </span>
                        <span v-else>
                            Other News
                        </span>
                    </a>
                </div>
            </div>

        </div>
    </div>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import 'vue3-carousel/dist/carousel.css'
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "PragmaticaBook, Arial, sans-serif" };
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, Carousel, Slide, Pagination, Navigation, DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            tabaktif: encodeURIComponent(CryptoJS.AES.encrypt('', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            datapesan: '',
            datamaster: [],
            tahun: new Date().getFullYear(),
            slides: [],
            breakpoints: {
                // 700px and up
                700: {
                    itemsToShow: 1,
                    snapAlign: 'center',
                },
                // 1024 and up
                1024: {
                    itemsToShow: 1,
                    snapAlign: 'start',
                },
            },
            bahasa: localStorage.getItem("bahasasistem"),
            databeranda: [],
            databerita: [],
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_beranda-Gambar?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),
            dataproyek: [],
            seriesproyek: [],
            chartOptionsproyek: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'PragmaticaBook, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1000000000).toFixed(0).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' M';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1000000000000).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' T'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datawaktu: [],
            serieswaktu: [],
            chartOptionswaktu: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'PragmaticaBook, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datapv: [],
            seriespv: [],
            chartOptionspv: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'PragmaticaBook, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datamonitoring: [],
            seriesmonitoring: [],
            chartOptionsmonitoring: {
                chart: {
                    width: '100%',
                    height: 450,
                    type: 'line',
                    zoom: {
                        type: 'x',
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        autoSelected: 'zoom'
                    }
                },
                colors: ['#00CED1', '#FFD700', '#9370DB', '#4682B4', '#32CD32'],
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Average High & Low Temperature',
                    align: 'center'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: ''
                    }
                },
                yaxis: {
                    title: {
                        text: ''
                    },
                },
                legend: {
                    position: 'bottom',
                    floating: true,
                    offsetY: -10,
                    offsetX: -5,
                    show: true,
                }
            },
            jumlahtotalpaket: 0,
            jumlahpaketcwPratender: 0,
            jumlahpaketcwtender: 0,
            jumlahpaketcwog: 0,
            jumlahpaketcwfinish: 0,
            jumlahpaketcwontarget: 0,
            jumlahpaketcwbehindtarget: 0,
            jumlahpaketconsultPratender: 0,
            jumlahpaketconsulttender: 0,
            jumlahpaketconsultog: 0,
            jumlahpaketconsultfinish: 0,
            jumlahpaketconsultontarget: 0,
            jumlahpaketconsultbehindtarget: 0,
            jumlahpaketbarangPratender: 0,
            jumlahpaketbarangtender: 0,
            jumlahpaketbarangog: 0,
            jumlahpaketbarangfinish: 0,
            jumlahpaketbarangontarget: 0,
            jumlahpaketbarangbehindtarget: 0,
            jumlahpaketjasaPratender: 0,
            jumlahpaketjasatender: 0,
            jumlahpaketjasaog: 0,
            jumlahpaketjasafinish: 0,
            jumlahpaketjasaontarget: 0,
            jumlahpaketjasabehindtarget: 0,
        };
    },
    methods: {
        ambilgambar(id) {
            var modal = document.getElementById("myModal");
            // Get the image and insert it inside the modal - use its "alt" text as a caption
            var img = document.getElementById(id);
            var modalImg = document.getElementById("img01");
            var captionText = document.getElementById("caption");
            modal.style.display = "block";
            modalImg.src = img.src;
            captionText.innerHTML = img.alt;

            // Get the <span> element that closes the modal
            var span = document.getElementsByClassName("close")[0];

            // When the user clicks on <span> (x), close the modal
            span.onclick = function () {
                modal.style.display = "none";
            }
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovation-GetSlider?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.slides = [];
                        this.datamaster = Response.data.content.data;
                        if ((this.bahasa == null) || (this.bahasa == 'ina')) {
                            this.datamaster.forEach((item) => {
                                this.slides.push({
                                    id: item.id,
                                    title: item.nama,
                                    url: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=' + item.filenya_slider,
                                });
                            });
                        }
                        else {
                            this.datamaster.forEach((item) => {
                                this.slides.push({
                                    id: item.id,
                                    title: item.nama_eng,
                                    url: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=' + item.filenya_slider,
                                });
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.slides = [];
                console.log(error);
                this.halamanloading = false;
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovation-GetInfoBeranda?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        var datasementara = [];
                        this.databeranda = [];
                        datasementara = Response.data.content.data;
                        datasementara.forEach((item) => {
                            this.databeranda.push({
                                id: item.id,
                                nama: item.nama,
                                nama_eng: item.nama_eng,
                                konten: atob(item.konten),
                                konten_eng: atob(item.konten_eng),
                                filenya_beranda: item.filenya_beranda,
                                tampilpublik: item.tampilpublik,
                            });
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.slides = [];
                this.halamanloading = false;
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovation-NewsUpdate?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        var datasementara = [];
                        this.databerita = [];
                        datasementara = Response.data.content.data;
                        datasementara.forEach((item) => {
                            this.databerita.push({
                                id: item.id,
                                nama: item.nama,
                                tanggal: item.tanggal,
                                nama_eng: item.nama_eng,
                                konten: (item.isi).substring(0, 100) + '...',
                                konten_eng: (item.isi_eng).substring(0, 100) + '...',
                                kontenfull: this.G_formatDate(item.tanggal) + item.isi + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                                konten_eng_full: this.G_formatDateEng(item.tanggal) + item.isi_eng + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                                filenya_berita: item.filenya_berita,
                            });
                        });

                    }
                    else {
                        this.databerita = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.databerita = [];
                //console.log(error);
                this.halamanloading = false;
            });

            this.halamanloading = true;
            const data = {
                tamuparastapa: 'tamuparastapa',
                project_id: this.project_id
            };
            const mainAPIVisitor = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPIVisitor.post("parastapainnovatioVisitor-PullVisitor", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        this.halamanloading = false;
                        return false;
                    }
                    else {
                        this.halamanloading = false;
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                }
            )


            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-Proyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataproyek = [];
                        this.seriesproyek = [];

                        this.chartOptionsproyek = {
                            labels: []
                        };
                        this.dataproyek = Response.data.content.data;
                        this.tanggalsinkron = this.dataproyek[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = this.dataproyek[0].TanggalDataMonev;
                        this.datawaktu = [];
                        this.serieswaktu = [];

                        this.chartOptionswaktu = {
                            labels: []
                        };
                        this.datawaktu = Response.data.content.data;
                        this.datapv = [];
                        this.seriespv = [];

                        this.chartOptionspv = {
                            labels: []
                        };
                        
                    }

                    this.jumlahtotalpaket = this.dataproyek[0].jumlahtotalpaket;
                    this.jumlahpaketcwPratender = this.dataproyek[0].jumlahpaketcwPratender;
                    this.jumlahpaketcwtender = this.dataproyek[0].jumlahpaketcwtender;
                    this.jumlahpaketcwog = this.dataproyek[0].jumlahpaketcwog;
                    this.jumlahpaketcwfinish = this.dataproyek[0].jumlahpaketcwfinish;
                    this.jumlahpaketcwontarget = this.dataproyek[0].jumlahpaketcwontarget;
                    this.jumlahpaketcwbehindtarget = this.dataproyek[0].jumlahpaketcwbehindtarget;
                    this.jumlahpaketconsultPratender = this.dataproyek[0].jumlahpaketconsultPratender;
                    this.jumlahpaketconsulttender = this.dataproyek[0].jumlahpaketconsulttender;
                    this.jumlahpaketconsultog = this.dataproyek[0].jumlahpaketconsultog;
                    this.jumlahpaketconsultfinish = this.dataproyek[0].jumlahpaketconsultfinish;
                    this.jumlahpaketconsultontarget = this.dataproyek[0].jumlahpaketconsultontarget;
                    this.jumlahpaketconsultbehindtarget = this.dataproyek[0].jumlahpaketconsultbehindtarget;
                    this.jumlahpaketbarangPratender = this.dataproyek[0].jumlahpaketbarangPratender;
                    this.jumlahpaketbarangtender = this.dataproyek[0].jumlahpaketbarangtender;
                    this.jumlahpaketbarangog = this.dataproyek[0].jumlahpaketbarangog;
                    this.jumlahpaketbarangfinish = this.dataproyek[0].jumlahpaketbarangfinish;
                    this.jumlahpaketbarangontarget = this.dataproyek[0].jumlahpaketbarangontarget;
                    this.jumlahpaketbarangbehindtarget = this.dataproyek[0].jumlahpaketbarangbehindtarget;
                    this.jumlahpaketjasaPratender = this.dataproyek[0].jumlahpaketjasaPratender;
                    this.jumlahpaketjasatender = this.dataproyek[0].jumlahpaketjasatender;
                    this.jumlahpaketjasaog = this.dataproyek[0].jumlahpaketjasaog;
                    this.jumlahpaketjasafinish = this.dataproyek[0].jumlahpaketjasafinish;
                    this.jumlahpaketjasaontarget = this.dataproyek[0].jumlahpaketjasaontarget;
                    this.jumlahpaketjasabehindtarget = this.dataproyek[0].jumlahpaketjasabehindtarget;
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datamonitoring = [];
                this.seriesmonitoring = [];
                this.dataproyek = [];
                this.seriesproyek = [];
                this.tanggalsinkron = new Date();
                this.chartOptionsproyek = {
                    labels: []
                };

                this.datawaktu = [];
                this.serieswaktu = [];
                this.tanggalsinkron = new Date();
                this.chartOptionswaktu = {
                    labels: []
                };

                this.datapv = [];
                this.seriespv = [];
                this.tanggalsinkron = new Date();
                this.chartOptionspv = {
                    labels: []
                };
                //console.log(error);
                this.halamanloading = false;
            });
            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-ProyekFMNJP?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataproyek = [];
                        this.seriesproyek = [];

                        this.chartOptionsproyek = {
                            labels: []
                        };
                        this.dataproyek = Response.data.content.data;
                        this.tanggalsinkron = this.dataproyek[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = this.dataproyek[0].TanggalDataMonev;
                        this.datawaktu = [];
                        this.serieswaktu = [];

                        this.chartOptionswaktu = {
                            labels: []
                        };
                        this.datawaktu = Response.data.content.data;
                        this.datapv = [];
                        this.seriespv = [];

                        this.chartOptionspv = {
                            labels: []
                        };
                        this.datapv = Response.data.content.data;
                        this.chartOptionspv.plotOptions = {
                            pie: {
                                donut: {
                                    labels: {
                                        show: true,
                                        name: {
                                            formatter: function (value) {
                                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                            },
                                        },
                                        value: {
                                            formatter: function (val) {
                                                return (val / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                            }
                                        },
                                        total: {
                                            show: true,
                                            label: this.dataproyek[0].PVStatus,
                                            color: '#111',
                                            formatter: function (w) {
                                                return ''
                                            }
                                        }
                                    }
                                }
                            }
                        };
                        //alert(JSON.stringify(this.dataproyek));
                        this.seriesproyek.push(this.dataproyek[0].Realisasi);
                        this.seriesproyek.push(this.dataproyek[0].BelumRealisasi);

                        this.serieswaktu.push(this.datawaktu[0].ElapstimeusedBulan);
                        this.serieswaktu.push(this.datawaktu[0].WaktuLoanBulan - this.datawaktu[0].ElapstimeusedBulan);
                        var datapvnya = parseFloat(this.datapv[0].PV).toFixed(2);
                        var datakurangpvnya = parseFloat(this.datapv[0].PVRemaining).toFixed(2);
                        //alert(typeof parseFloat(datapvnya));
                        this.seriespv.push(parseFloat(datapvnya));
                        this.seriespv.push(parseFloat(datakurangpvnya));
                        //alert(this.seriespv);
                        this.chartOptionspv.colors = [this.datapv[0].PVColor, '#3a4767'];
                        var texttrilliyun = '';
                        var textrealisasi = '';
                        var textjudul = '';
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            texttrilliyun = 'Dalam Triliyun (Rp.)';
                            textrealisasi = 'Realisasi';
                            textjudul = 'Perbandingan OWP, AWP dan Realisasi Kumulatif Tahunan';
                            this.chartOptionsproyek.labels.push('Sudah dicairkan');
                            this.chartOptionsproyek.labels.push('Belum dicairkan');
                            this.chartOptionsproyek.title = {
                                text: 'Realisasi Pencairan Proyek',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionswaktu.labels.push('Waktu terpakai');
                            this.chartOptionswaktu.labels.push('Waktu tersisa');
                            this.chartOptionswaktu.title = {
                                text: 'Rasio Waktu Proyek',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionspv.labels.push('Progress Variant');
                            this.chartOptionspv.labels.push('Kekurangan ke ideal');
                            this.chartOptionspv.title = {
                                text: 'Progress Variant',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            };


                        }
                        else {
                            texttrilliyun = 'in Trilions (IDR)';
                            textrealisasi = 'Realization';
                            textjudul = 'Comparison of OWP, AWP and Annual Cumulative Realization';
                            this.chartOptionsproyek.labels.push('Disbursed');
                            this.chartOptionsproyek.labels.push('Undisbursed');
                            this.chartOptionsproyek.title = {
                                text: 'Realization of Project Disbursement',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionswaktu.labels.push('Elapse time');
                            this.chartOptionswaktu.labels.push('Time left');
                            this.chartOptionswaktu.title = {
                                text: 'Project Elapse Time Ratio',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionspv.labels.push('Progress Variant');
                            this.chartOptionspv.labels.push('Deviciency to ideals');
                            this.chartOptionspv.title = {
                                text: 'Progress Variant',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            };


                        }

                        this.series_newpv = [{
                            data: []
                        }];

                        this.series_newpv = [{
                            data: [parseFloat(this.datapv[0].PV_OCR).toFixed(2), parseFloat(this.datapv[0].PV_UK).toFixed(2), parseFloat(this.datapv[0].PV).toFixed(2)]
                        }];

                        this.chartOptions_newpv = {
                            colors: [],
                            xaxis: {
                                categories: [],
                            },
                        }

                        this.chartOptions_newpv = {
                            colors: [this.datapv[0].PVColor_OCR, this.datapv[0].PVColor_UK, this.datapv[0].PVColor],
                            xaxis: {
                                categories: ['OCR  (' + this.datapv[0].PVStatus_OCR + ')', 'UK-ACGF TF (' + this.datapv[0].PVStatus_UK + ')', 'All (' + this.datapv[0].PVStatus + ')'],
                            },
                        }

                        this.datamonitoring = [];
                        this.seriesmonitoring = [];
                        this.datamonitoring = Response.data.content.data;
                        var temptahun = [];
                        var tempowp = [];
                        var tempawp = [];
                        var tempspm = [];
                        var tempowpmonev = [];
                        var temprealisasimonev = [];
                        for (let i = 0; i < this.dataproyek[0].Tahun.length; i++) {
                            temptahun.push(this.dataproyek[0].Tahun[i].tahun);
                            tempowp.push(this.dataproyek[0].Tahun[i].owptrilyun);
                            tempawp.push(this.dataproyek[0].Tahun[i].awptrilyun);
                            tempspm.push(this.dataproyek[0].Tahun[i].spmtrilyun);
                            tempowpmonev.push(this.dataproyek[0].Tahun[i].dataowpmonevtrilyun);
                            if (this.dataproyek[0].Tahun[i].datarealisasimonevtrilyun > 0) {
                                temprealisasimonev.push(this.dataproyek[0].Tahun[i].datarealisasimonevtrilyun);
                            }
                            
                        }

                        this.seriesmonitoring.push(
                            {
                                name: "OWP",
                                data: tempowp
                            },
                            {
                                name: "AWP",
                                data: tempawp
                            },
                            {
                                name: textrealisasi,
                                data: temprealisasimonev
                            }
                        )
                        //alert(temptahun);
                        this.chartOptionsmonitoring = {
                            title: {
                                text: textjudul,
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            },
                            xaxis: {
                                categories: temptahun,
                            },
                            yaxis: {
                                title: {
                                    text: texttrilliyun
                                },
                            },
                            legend: {
                                position: 'bottom',
                                floating: true,
                                offsetY: 10,
                                offsetX: -5,
                                show: true,
                            }
                        };

                        //alert(JSON.stringify(this.chartOptionsmonitoring.xaxis));
                    }
                    else {
                        this.datamonitoring = [];
                        this.seriesmonitoring = [];

                        this.dataproyek = [];
                        this.seriesproyek = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionsproyek = {
                            labels: []
                        };

                        this.datawaktu = [];
                        this.serieswaktu = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionswaktu = {
                            labels: []
                        };

                        this.datapv = [];
                        this.seriespv = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionspv = {
                            labels: []
                        };
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datamonitoring = [];
                this.seriesmonitoring = [];
                this.dataproyek = [];
                this.seriesproyek = [];
                this.tanggalsinkron = new Date();
                this.chartOptionsproyek = {
                    labels: []
                };

                this.datawaktu = [];
                this.serieswaktu = [];
                this.tanggalsinkron = new Date();
                this.chartOptionswaktu = {
                    labels: []
                };

                this.datapv = [];
                this.seriespv = [];
                this.tanggalsinkron = new Date();
                this.chartOptionspv = {
                    labels: []
                };
                //console.log(error);
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style>
.carousel__prev,
.carousel__next {
    box-sizing: content-box;
    border: 5px solid #0055aa;
    border-radius: 40px;
    background-color: #0055aa;
    color: aliceblue;
    height: 50px;
    width: 50px;
}

/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 888888;
    /* Sit on top */
    padding-top: 20px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(251, 248, 248, 1);
    /* Fallback color */
    background-color: rgb(251, 248, 248, 1);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    float: left;
    margin-right: 10px;
    margin-left: 60px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 90%;
    max-width: 90%;
    text-align: justify;
    color: #111;
    padding: 10px 0;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 20px;
    right: 35px;
    color: #111;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 99999;
}

.close:hover,
.close:focus {
    color: #111;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}

.gambar:hover {
    cursor: pointer;
    opacity: 0.5;
}
</style>